/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RequestItemVisibility } from './RequestItemVisibility';
import {
    RequestItemVisibilityFromJSON,
    RequestItemVisibilityFromJSONTyped,
    RequestItemVisibilityToJSON,
    RequestItemVisibilityToJSONTyped,
} from './RequestItemVisibility';

/**
 * 
 * @export
 * @interface UpdateRequestItemRequest
 */
export interface UpdateRequestItemRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * 
     */
    label?: string;
    /**
     * 
     */
    instructions?: string | null;
    /**
     * 
     */
    participant_reason?: string | null;
    /**
     * 
     */
    item_group?: string | null;
    /**
     * 
     */
    visibility?: RequestItemVisibility;
    /**
     * 
     */
    due_at?: Date | null;
    /**
     * 
     */
    assigned_user_id?: string | null;
    /**
     * 
     */
    sort_order?: number;
    /**
     * 
     */
    status?: UpdateRequestItemRequestStatusEnum;
    /**
     * 
     */
    reason?: string;
}


/**
 * @export
 */
export const UpdateRequestItemRequestStatusEnum = {
    Needed: 'needed',
    Fulfilled: 'fulfilled',
    Withdrawn: 'withdrawn',
} as const;
export type UpdateRequestItemRequestStatusEnum = typeof UpdateRequestItemRequestStatusEnum[keyof typeof UpdateRequestItemRequestStatusEnum];


/**
 * Check if a given object implements the UpdateRequestItemRequest interface.
 */
export function instanceOfUpdateRequestItemRequest(value: object): value is UpdateRequestItemRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    return true;
}

export function UpdateRequestItemRequestFromJSON(json: any): UpdateRequestItemRequest {
    return UpdateRequestItemRequestFromJSONTyped(json, false);
}

export function UpdateRequestItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRequestItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'label': json['label'] == null ? undefined : json['label'],
        'instructions': json['instructions'] === undefined ? undefined : json['instructions'] === null ? null : json['instructions'],
        'participant_reason': json['participant_reason'] === undefined ? undefined : json['participant_reason'] === null ? null : json['participant_reason'],
        'item_group': json['item_group'] === undefined ? undefined : json['item_group'] === null ? null : json['item_group'],
        'visibility': json['visibility'] == null ? undefined : RequestItemVisibilityFromJSON(json['visibility']),
        'due_at': json['due_at'] === undefined ? undefined : json['due_at'] === null ? null : (parseDateTime(json['due_at'])),
        'assigned_user_id': json['assigned_user_id'] === undefined ? undefined : json['assigned_user_id'] === null ? null : json['assigned_user_id'],
        'sort_order': json['sort_order'] == null ? undefined : json['sort_order'],
        'status': json['status'] == null ? undefined : json['status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function UpdateRequestItemRequestToJSON(json: any): UpdateRequestItemRequest {
    return UpdateRequestItemRequestToJSONTyped(json, false);
}

export function UpdateRequestItemRequestToJSONTyped(value?: UpdateRequestItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'label': value['label'],
        'instructions': value['instructions'],
        'participant_reason': value['participant_reason'],
        'item_group': value['item_group'],
        'visibility': RequestItemVisibilityToJSON(value['visibility']),
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'assigned_user_id': value['assigned_user_id'],
        'sort_order': value['sort_order'],
        'status': value['status'],
        'reason': value['reason'],
    };
}

